import { ModifyWorkspaceUsers } from "./ModifyWorkspaceUsers";
import { ModifyWorkspacePlan } from "./ModifyWorkspacePlan";
import { PaymentMethod } from "./PaymentMethod";

import * as util from "./util";

const Analytics = {
    ModifyWorkspacePlan,
    ModifyWorkspaceUsers,
    PaymentMethod,
    util,
};

export default Analytics;
